export const INVOICE_TRANSITIONS = [
    // The accountant assigns a project, a manager and a category.
    { from: 'NEW', to: 'ASSIGNED', roles: ['ACCOUNTANT', 'ADMIN'] },
    // Company-wide costs have no site manager to review them, so go straight to the owner.
    { from: 'NEW', to: 'APPROVED_BY_MANAGER', roles: ['ACCOUNTANT', 'ADMIN'] },
    // ...and can correct that booking while it is still with the manager.
    // Without this, a wrong project or a mistyped retention is permanent — the
    // only escape would be asking the manager to reject the invoice.
    { from: 'ASSIGNED', to: 'ASSIGNED', roles: ['ACCOUNTANT', 'ADMIN'] },
    // Removing the manager turns an already-booked invoice into a company-wide cost.
    { from: 'ASSIGNED', to: 'APPROVED_BY_MANAGER', roles: ['ACCOUNTANT', 'ADMIN'] },
    // The site manager confirms the delivery, or pushes back.
    { from: 'ASSIGNED', to: 'APPROVED_BY_MANAGER', roles: ['SITE_MANAGER', 'ADMIN'] },
    { from: 'ASSIGNED', to: 'DISPUTED', roles: ['SITE_MANAGER', 'ADMIN'] },
    // A disputed invoice goes back to the accountant for reassignment.
    { from: 'DISPUTED', to: 'ASSIGNED', roles: ['ACCOUNTANT', 'ADMIN'] },
    { from: 'DISPUTED', to: 'APPROVED_BY_MANAGER', roles: ['ACCOUNTANT', 'ADMIN'] },
    // The owner releases it for payment. Since 3.09.2026 the accountant may do it
    // in the owner's place, always and without limits — but the invoice is then
    // marked `approvedForPaymentWithoutOwner` for good.
    { from: 'APPROVED_BY_MANAGER', to: 'APPROVED_FOR_PAYMENT', roles: ['ADMIN', 'ACCOUNTANT'] },
    // ...or sends it back to the manager if something looks off.
    { from: 'APPROVED_BY_MANAGER', to: 'ASSIGNED', roles: ['ADMIN'] },
    // Accounting records the transfer.
    { from: 'APPROVED_FOR_PAYMENT', to: 'PAID', roles: ['ACCOUNTANT', 'ADMIN'] },
];
export function findTransition(from, to) {
    return INVOICE_TRANSITIONS.find((transition) => transition.from === from && transition.to === to);
}
export function canTransition(from, to, role) {
    const transition = findTransition(from, to);
    return transition !== undefined && transition.roles.includes(role);
}
export function nextStatusesFor(from, role) {
    return INVOICE_TRANSITIONS.filter((transition) => transition.from === from && transition.roles.includes(role)).map((transition) => transition.to);
}
/**
 * Statuses in which an invoice is still waiting for somebody to act.
 * Used for the "what is waiting for me" counters that every role's home screen
 * is built around.
 */
export const OPEN_INVOICE_STATUSES = [
    'NEW',
    'ASSIGNED',
    'DISPUTED',
    'APPROVED_BY_MANAGER',
    'APPROVED_FOR_PAYMENT',
];
//# sourceMappingURL=invoice-transitions.js.map